window.addEventListener("load", function () {
  if ($("#swiperUuhoa").length > 0) {
    new Swiper("#swiperUuhoa", {
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 50,
      breakpoints: {
        769: { spaceBetween: 45 },
      },
      navigation: {
        nextEl: ".swiper-button-next--uuhoa",
        prevEl: ".swiper-button-prev--uuhoa",
      },
    });
  }
});
